import React, { FunctionComponent } from 'react'
import styles from './ColorPicker.module.sass'
import clsx from 'clsx'
import CheckIcon from 'files/check.svg'

interface Props {
    className?: string,
    color?: string,
    selected?: boolean,
    active?: boolean
    onClick?: () => void,
}

const Color: FunctionComponent<Props> = props => {
    return <span
        className={clsx(
            props.className,
            styles.color,
            {
                [styles.selected]: props.selected,
                [styles.active]: props.active,
                [styles.empty]: !props.color,
            }
        )}
        style={{ '--color': props.color } as React.CSSProperties}
        onClick={props.onClick}
    >
        {
            (props.selected || props.active) ?
                <CheckIcon/> :
                <span>{props.children ?? '###'}</span>

        }
    </span>
}

export default Color